export const FILTER_TYPES = {
  DROP_DOWN_SINGLE_SELECT: 'Dropdown_Singleselect',
  RANGE: 'range',
  TABS_MULTI_SELECT: 'Tabs_Multiselect',
  DOUBLE_TAB_SINGLE_SELECT: 'Double_Tab_Singleselect',
  ICON_MULTI_SELECT: 'Icon_Multiselect',
  CHECKBOX: 'Checkbox',
  MULTI_SELECT: 'multiSelect',
};

export const THEMES_FILTER_NAME = 'themes';

export const LISTING_PAGE_NAME = 'listing';

export const SEARCH_WIDGET_OMNITURE = 'listing_filter_search';
